import { render, staticRenderFns } from "./AddressTypeChip.vue?vue&type=template&id=7b93a78b&"
import script from "./AddressTypeChip.vue?vue&type=script&lang=js&"
export * from "./AddressTypeChip.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports